import type { User } from 'types/UserZendesk';

const LOCAL_STORAGE_KEY = 'selectedUser';

export function saveSelectedUser(user: User): void {
  try {
    localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(user));
  } catch (error) {
    console.error('Erro ao salvar usuário no localStorage:', error);
  }
}

export function getSelectedUser(): User | null {
  try {
    const stored = localStorage.getItem(LOCAL_STORAGE_KEY);
    if (!stored) return null;
    return JSON.parse(stored);
  } catch (error) {
    console.error('Erro ao recuperar usuário do localStorage:', error);
    return null;
  }
}

export function removeSelectedUser(): void {
  try {
    localStorage.removeItem(LOCAL_STORAGE_KEY);
  } catch (error) {
    console.error('Erro ao remover usuário do localStorage:', error);
  }
}
